import { useFeatureFlag } from '@shape/feature-flag';
import { EventItem } from 'queries/events/types';
import { useGetAvaiableGraphsByEventId } from 'queries/sensors';
import { useState, useEffect } from 'react';

type chartTabsProps = {
  event: EventItem;
};
type ChartName = 'sensor' | 'feature' | 'radar' | 'risk' | 'amoeba';
export type ChartUrlList = { [key in ChartName]?: string };

const chartsOrder: ChartName[] = ['sensor', 'feature'];
const chartsScalingOrder: ChartName[] = ['risk', 'amoeba', 'radar', 'sensor', 'feature'];

export const useChartTabs = ({ event }: chartTabsProps) => {
  const scalingComponent = useFeatureFlag('scaling-components');

  const { data, isFetching } = useGetAvaiableGraphsByEventId(
    event.id,
    event.alarm_datetime_start,
    event.alarm_datetime_end,
  );
  const [chartsNames, setChartsNames] = useState<ChartName[]>([]);

  useEffect(() => {
    if (data?.plots) {
      const graphTypes = data.plots;
      const chartList = Object.keys(graphTypes).reduce((acc: string[], key) => {
        if (key === 'SENSOR') {
          return [...acc, 'sensor'];
        }
        if (key.includes('REFERENCE')) {
          return acc;
        }
        if (scalingComponent) {
          return [...acc, key.toLowerCase()];
        }

        return acc;
      }, []) as ChartName[];

      setChartsNames(
        chartList.sort((a, b) => {
          const order = event.model_name && scalingComponent ? chartsScalingOrder : chartsOrder;
          return order.indexOf(a) - order.indexOf(b);
        }),
      );
    }
  }, [data, isFetching, scalingComponent]);

  return { chartsNames, isFetching };
};
